import { Box, Drawer, TextField, Button, Typography, Stack } from '@mui/material';
import Confirm from 'components/Dialog';
import Header from 'components/Header';
import { BasePathProvider, useBasePath } from 'components/Providers';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { noteDelete, noteSave as saveNote } from 'store/evaluation/admin-evaluation'

export default function NoteDrawer({ open, onClose, standardId, evaluationId, selectedNote }) {
    const basePath = useBasePath();
    const dispatch = useDispatch();
    const [confirm, setConfirm] = useState(false)

    const { control, handleSubmit, reset, formState: { isDirty, isSubmitting } } = useForm({
        defaultValues: {
            note: selectedNote?.note || '',
        },
    });

    useEffect(() => {
        reset({
            note: selectedNote?.note || '',
        });
    }, [selectedNote, reset]);

    const onSubmit = async (data) => {
        const payload = {
            note: data.note,
            ...(selectedNote?.id ? { id: selectedNote.id } : { standardId, evaluationId })
        };

        await dispatch(saveNote(payload));
        onClose();
        reset({ note: '' });
    };

    const onDestroy = async () => {
        setConfirm(false);
        dispatch(noteDelete({ id: selectedNote.id }));
        onClose()
    };

    return (
        <BasePathProvider value={`${basePath}/admin/new`}>
            <Drawer anchor="right" open={open} onClose={onClose}>
                <Header title="Add Note" small borderBottom />
                { selectedNote?.id && (
                <Box width={600} p={2}>
                    <Typography variant="body1" fontWeight={500} pb={2}>Note Details</Typography>
                    <Stack direction="column" >
                        <Typography variant="body2" color={'text.secondary'}>
                            Note Added By
                        </Typography>
                        <Typography variant="body1" >
                            {selectedNote?.person?.lastName}, {selectedNote?.person?.firstName}
                        </Typography>
                    </Stack>
                    <Stack direction="column" pt={1}>
                        <Typography variant="body2" color={'text.secondary'}>
                            Added On
                        </Typography>
                        <Typography variant="body1" >
                            {dayjs(selectedNote?.createdAt).format('MM/DD/YYYY')}
                        </Typography>
                    </Stack>
                </Box>    
                )}
                <Box p={2} width={600}>
                    <Controller
                        name='note'
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                multiline
                                fullWidth
                                label="Note"
                                variant="outlined"
                                onChange={(e) => {
                                    field.onChange(e);
                                }}
                            />
                        )}
                    />
                    <Box mt={2} display="flex" gap="8px" justifyContent="flex-end">
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => setConfirm(true)}
                            size='small'
                            disabled={!selectedNote?.id || isSubmitting}
                        >
                            Delete
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSubmit(onSubmit)}
                            disabled={isSubmitting || !isDirty}
                            size='small'
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Drawer>
            <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onDestroy} />
        </BasePathProvider>
    );
}
